import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { FuseNavigationItem } from '../../../../types';
import { NppPermessiService } from 'app/main/pages/npp/services/npp-permessi.service';
import { NppWebinarService } from 'app/main/pages/npp/services/npp-webinar.service';

@Component({
  standalone: true,
  imports: [NgClass, NgStyle, NgTemplateOutlet, RouterLink, RouterLinkActive, MatIconModule],
  selector: 'fuse-nav-vertical-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class FuseNavVerticalItemComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  classes = 'nav-item';

  @Input()
  item: FuseNavigationItem;

  isVisibleByNppPermission = true;
  showWebinarLiveBadge = false;

  private nppPermessiSubscription: Subscription;
  private nppWebinarSubscription: Subscription;

  /**
   * Constructor
   */
  constructor(
    public nppPermessiService: NppPermessiService,
    private nppWebinarService: NppWebinarService
  ) {}

  ngOnInit(): void {
    if (!this.item.dlsMenuPermission) {
      this.caricaStatoWebinarLive();
      return;
    }

    this.isVisibleByNppPermission = false;
    this.nppPermessiSubscription = this.nppPermessiService.getPermessi().subscribe(permessi => {
      const menu = permessi && permessi.menu ? permessi.menu : {};
      this.isVisibleByNppPermission = menu[this.item.dlsMenuPermission] === true;

      if (this.isVisibleByNppPermission) {
        this.caricaStatoWebinarLive();
      }
    });
  }

  private caricaStatoWebinarLive(): void {
    if (!this.item || this.item.id !== 'dls-webinar' || this.nppWebinarSubscription) {
      return;
    }

    this.nppWebinarSubscription = this.nppWebinarService.liveVideo$.subscribe(response => {
      this.showWebinarLiveBadge = !!(response && response.isLive && response.videos && response.videos.length);
    });
  }

  ngOnDestroy(): void {
    if (this.nppPermessiSubscription) {
      this.nppPermessiSubscription.unsubscribe();
    }

    if (this.nppWebinarSubscription) {
      this.nppWebinarSubscription.unsubscribe();
    }
  }
}
